class MFRHeroSection {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      video: ".hero-section__background video",
      control: ".hero-section__video-control",
    };

    this.init();
  }

  init() {
    this.$video = this.$element.find(this.selectors.video);
    this.$control = this.$element.find( this.selectors.control );

    this.$control.on( "click", this.__handleControlClick.bind( this ) );

    // this.handleVideoEvents();
  }

  __handleControlClick( e ) {
    if (this.$control.hasClass( "play" ))
      this.$video.get(0).play();
    else
      this.$video.get(0).pause();
  }

  handleVideoEvents() {
    this.$video.on( "pause", () => this.$control.updateState( "pause" ) );
    this.$video.on("play", () => this.$control.updateState("play"));
  }
}